import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProDetailNegotiateView のスタイル
 */
export const hotlineProDetailNegotiateViewStyle = tv({
    slots: {
        content: [
            'flex flex-col gap-24',
            'py-24 px-16 md:p-32',
            'mb-8',
            'bg-white',
            'shadow-md',
            'md:rounded-b-md md:rounded-tr-md',
        ],
        title: [
            textStyle({ color: 'base', isBold: true, size: 'md' }),
            'flex-shrink-0',
        ],
    },
});
